var map = {
	"./views/business/bulk_cargo/index": [
		"a1e5",
		"chunk-964b5872",
		"chunk-1650d2f2",
		"chunk-33d6166f"
	],
	"./views/business/business_info/index": [
		"7806",
		"chunk-964b5872",
		"chunk-25007469",
		"chunk-909b5540"
	],
	"./views/business/color_diamond/index": [
		"7a63",
		"chunk-964b5872",
		"chunk-1650d2f2",
		"chunk-2d0e143d"
	],
	"./views/business/jewelry_brand/index": [
		"d73e",
		"chunk-964b5872",
		"chunk-25007469",
		"chunk-2ef867fa"
	],
	"./views/business/jewelry_products/index": [
		"93e4",
		"chunk-964b5872",
		"chunk-10800dd8"
	],
	"./views/business/white_diamond/index": [
		"4b44",
		"chunk-964b5872",
		"chunk-1650d2f2",
		"chunk-2d0cbaa4"
	],
	"./views/home/home_page/index": [
		"bdf4",
		"chunk-6fd0e8b6"
	],
	"./views/layout/components/Sidebar/index": [
		"30c6"
	],
	"./views/layout/components/index": [
		"38e2"
	],
	"./views/login/index": [
		"9ed6",
		"chunk-8d799d86"
	],
	"./views/order_management/declaration_order/index": [
		"f5f5",
		"chunk-2e601751"
	],
	"./views/statistical_management/business_statistical/index": [
		"cd87",
		"chunk-7e0eba8f"
	],
	"./views/statistical_management/gia_browse/index": [
		"641c",
		"chunk-66cf2bc2"
	],
	"./views/statistical_management/gia_collect/index": [
		"74a7",
		"chunk-00f2b9fc"
	],
	"./views/statistical_management/jewellery_browse/index": [
		"7b4c",
		"chunk-abf4ca16"
	],
	"./views/statistical_management/jewellery_collect/index": [
		"d081",
		"chunk-234e0eec"
	],
	"./views/system/api/index": [
		"5582",
		"chunk-fc18d996"
	],
	"./views/system/material_setting/index": [
		"abe2",
		"chunk-d33a2f4c"
	],
	"./views/system/menu/index": [
		"f794",
		"chunk-69508a98"
	],
	"./views/system/operation_log/index": [
		"e6e1",
		"chunk-2d226193"
	],
	"./views/system/price_discount/index": [
		"71af",
		"chunk-02147c17"
	],
	"./views/system/role/index": [
		"70eb",
		"chunk-d41a49ca"
	],
	"./views/system/rule/index": [
		"81cd",
		"chunk-4357edcb"
	],
	"./views/system/user/index": [
		"1f34",
		"chunk-711d6fd1"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3ab3";
module.exports = webpackAsyncContext;